import React, { useCallback } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { cashinStatus } from '@/mytickets/constants/cashinStatus';
import { cashinOfferStatus } from '@/mytickets/constants/cashinOfferStatus';
import Dialog from '@/ui/dialogs/Dialog';
import CashinNotAvailable from './CashinNotAvailable';
import OfferCashinDialog from './OfferCashinDialog';
import ActiveCashinDialog from './ActiveCashinDialog';
import PopupNg from '@/ui/PopupNg';
import { logCashinTransactionResultConfirmed } from 'nike-ui/src/common/logging/cashin/log';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';
import { activeTransaction$$, cashinOfferByTicketId$$ } from 'nike-ui/src/components/turboLive/components/cashin/subs';

function CashinPopup({ ticketId, cashinPosition, showConfirmDialog = true }) {
    const derefSub = useReframe();
    const cashinOffer = derefSub(cashinOfferByTicketId$$(ticketId));
    const cashinTransaction = derefSub(activeTransaction$$(ticketId));

    let content;
    let className = '';

    const closeCashinDialogAndClosingMode = useCallback(
        message => {
            dispatch(clearCashinClosingMode);
            PopupNg.dispatcher.close('ticketus/cashin-dialog');
            logCashinTransactionResultConfirmed({ ticketId, offer: cashinOffer, message });
        },
        [ticketId, cashinOffer]
    );

    const closeCashinDialog = useCallback(
        message => {
            PopupNg.dispatcher.close('ticketus/cashin-dialog');
            logCashinTransactionResultConfirmed({ ticketId, offer: cashinOffer, message });
        },
        [ticketId, cashinOffer]
    );

    //mame aj transakciu - prebieha samotny odkup (transakcia) a je transakcia aktivna
    if (cashinOffer && cashinTransaction) {
        content = (
            <ActiveCashinDialog
                cashinTransaction={cashinTransaction}
                closeDialogFailed={closeCashinDialog}
                closeDialogSuccess={closeCashinDialogAndClosingMode}
                isTransactionIdSynchronized
            />
        );

        if (cashinTransaction.getIn(['status']) === cashinStatus.Approved) {
            className = 'success';
        }
        if (cashinTransaction.getIn(['status']) === cashinStatus.Rejected) {
            className = 'failure';
        }

        //mame len offer
    } else if (cashinOffer) {
        switch (cashinOffer.get('status')) {
            case cashinOfferStatus.NotAvailable:
            case cashinOfferStatus.Finished:
            case cashinOfferStatus.Stopped:
                className = 'warn';
                content = (
                    <CashinNotAvailable cashinOfferStatus={cashinOffer.get('status')} closeDialog={closeCashinDialog} />
                );
                break;
            default:
                content = showConfirmDialog ? (
                    <OfferCashinDialog
                        cashinOffer={cashinOffer}
                        closeDialog={closeCashinDialog}
                        cashinPosition={cashinPosition}
                    />
                ) : null;
        }

        //chybaju data - riesime chybu
    } else {
        className = 'warn';
        content = (
            <CashinNotAvailable cashinOfferStatus={cashinOfferStatus.NotAvailable} closeDialog={closeCashinDialog} />
        );
    }

    return (
        <Dialog className={className} modal>
            {content}
        </Dialog>
    );
}

export default CashinPopup;
